import React from 'react'
import Link from 'hooks/Link'

const Content = () => {

    const TOC = [
        {
            title: "Investor's Pitch",
            desc: "One page summary to convince and prove the viability of the Project to the investors",
            link: "Investor’s-Pitch"
        },
        {
            title: "Dash Board",
            desc: "Pictorial Presentation of all the Financials of all the 5 Years",
            link: "DB"
        },
        {
            title: "Income Statement",
            desc: "Yearly Operational Performance of the business including Revenues, Gross Profit, Expenses and Net Profits",
            link: "IS"
        },
        {
            title: "Cash Flows",
            desc: "Depicts how much Cash business would generate during all the years from its Operations",
            link: "CF’s"
        },
        {
            title: "Balance Sheet",
            desc: "Balance Sheet provides the status of a business Assets and Liabilities for all the relevant years",
            link: "BS"
        },
        {
            title: "Project Feasibility Assessment",
            desc: "Confirms whether it's viable to invest in a business or othewise using the most authentic techniques of IRR, Payback Period and NPV",
            link: "Feasibility"
        },
        {
            title: "Business Valuation",
            desc: "Calculates the worth of a business using globally recognized techniques of Discounted Cash Flows & Exit Multiple Method",
            link: "BV"
        },
        {
            title: "Basis",
            desc: "Fundamental information on which all the model is based on",
            link: "Basis"
        },
        {
            title: "CAPEX - Input Tab",
            desc: "The details of all the Capital Expenditures required to be incurred for all the 5 years",
            link: "Capex"
        },
        {
            title: "OPEX - Input Tab",
            desc: "Operational Expenses to be incurred throughout the period",
            link: "Opex"
        },

    ]
    const TOC_Col_1 = TOC.slice(0, 7)
    const TOC_Col_2 = TOC.slice(7)
    return (
        <>

            <div className='Content-Main-Heading-container'>
                <div className='Double-heading-container'>

                    <h1 className='Content-main-heading-1'>
                        Table of <br /> Contents:
                    </h1>

                </div>
            </div>

            <div className='Heading-row'>
                <table className='Heading-row-t1'>
                    <tr>
                        <td>Tab#</td>
                        <td>Description</td>
                    </tr>
                </table>
                <table className='Heading-row-t2'>
                    <tr>
                        <td>Tab#</td>
                        <td>Description</td>
                    </tr>
                </table>
            </div>

            <div className='Table-of-content-main'>

                <div className='Table-of-content-inner'>

                    {
                        TOC_Col_1.map((item, Index) => (
                            <div className='TOC-Row'>
                                <div className='TOC-rows'>
                                    <div className='TOC-rows-num'>
                                        {Index + 1}
                                    </div>
                                    <div className='TOC-rows-title'>
                                        <Link to={`/investors-pitch/${item.link}`}><p className='TOC-row-h'>{item.title}</p></Link>

                                        <p className='TOC-row-d'>{item.desc}</p>
                                    </div>
                                </div>
                                {Index !== TOC_Col_1.length - 1 && <hr className='separator' />}
                            </div>
                        ))
                    }




                </div>
                <div className='Table-of-content-inner'>

                    {
                        TOC_Col_2.map((item, Index) => (
                            <div className='TOC-Row'>
                                <div className='TOC-rows'>
                                    <div className='TOC-rows-num'>
                                        {Index + 8}
                                    </div>
                                    <div className='TOC-rows-title'>
                                        <Link to={`/investors-pitch/${item.link}`}><p className='TOC-row-h'>{item.title}</p></Link>

                                        <p className='TOC-row-d'>{item.desc}</p>
                                    </div>
                                </div>
                                {Index !== TOC_Col_2.length - 1 && <hr className='separator' />}

                            </div>
                        ))
                    }




                </div>
            </div>
<br />










        </>
    )
}

export default Content